// TEMPORARY — DesiDime 16th birthday event, July 2026. Remove after event
// (see docs/superpowers/specs/2026-07-07-desidime-birthday-popup-2026-design.md).
import "stylesheets/birthday_popup_2026.scss";

const COOKIE_NAME = "dd_birthday_2026_seen";
const SHOW_DELAY_MS = 1500;
const MOBILE_MAX = 768;
const COOKIE_EXPIRES = new Date(2026, 6, 14); // July 14, 2026 (JS month is 0-indexed)

let _raf = null;
let _mouseHandler = null;
let _audioCtx = null;

const BALLOON_COLORS = ["#FE6301", "#F5A623", "#FF8A3D", "#FFC857", "#E55A00", "#FF5E8A", "#FF9F5A", "#FFD580", "#FF6B6B"];
const KNOT_COLORS    = ["#C44B00", "#C2840D", "#CC6520", "#CCA020", "#B54600", "#CC3060", "#CC7030", "#CCB040", "#CC4040"];

// Verbatim percent labels + geometry from the approved mockup.
const BALLOON_DATA = [
  { id: 1,  left: "2%",  size: 44, h: 53, dur: "9s",    delay: "0s",   sway: "3.4s", ci: 0, label: "20%", ls: 11 },
  { id: 2,  left: "8%",  size: 32, h: 38, dur: "12s",   delay: "1.8s", sway: "4.6s", ci: 1, label: "50%", ls: 9  },
  { id: 3,  left: "14%", size: 50, h: 60, dur: "8.5s",  delay: "0.4s", sway: "3.1s", ci: 2, label: "90%", ls: 12 },
  { id: 4,  left: "21%", size: 36, h: 43, dur: "11s",   delay: "2.5s", sway: "4.9s", ci: 3, label: "5%",  ls: 10 },
  { id: 5,  left: "28%", size: 40, h: 48, dur: "10s",   delay: "0.9s", sway: "3.7s", ci: 4, label: "75%", ls: 11 },
  { id: 6,  left: "34%", size: 28, h: 34, dur: "13s",   delay: "1.3s", sway: "5.2s", ci: 5, label: "30%", ls: 8  },
  { id: 7,  left: "41%", size: 46, h: 55, dur: "9.2s",  delay: "0.2s", sway: "3.3s", ci: 6, label: "60%", ls: 12 },
  { id: 8,  left: "48%", size: 38, h: 46, dur: "10.5s", delay: "1.7s", sway: "4.2s", ci: 7, label: "10%", ls: 10 },
  { id: 9,  left: "55%", size: 34, h: 41, dur: "11.5s", delay: "0.7s", sway: "4.9s", ci: 8, label: "95%", ls: 9  },
  { id: 10, left: "62%", size: 48, h: 58, dur: "8.8s",  delay: "2.1s", sway: "3.6s", ci: 0, label: "40%", ls: 12 },
  { id: 11, left: "68%", size: 30, h: 36, dur: "12.5s", delay: "0.5s", sway: "5.1s", ci: 1, label: "15%", ls: 8  },
  { id: 12, left: "74%", size: 42, h: 50, dur: "9.6s",  delay: "1.1s", sway: "3.9s", ci: 2, label: "80%", ls: 11 },
  { id: 13, left: "80%", size: 36, h: 43, dur: "10.8s", delay: "2.8s", sway: "4.4s", ci: 3, label: "25%", ls: 10 },
  { id: 14, left: "86%", size: 52, h: 62, dur: "8.2s",  delay: "0.3s", sway: "3.0s", ci: 4, label: "70%", ls: 12 },
  { id: 15, left: "92%", size: 29, h: 35, dur: "13.2s", delay: "1.5s", sway: "5.3s", ci: 5, label: "45%", ls: 8  },
  { id: 16, left: "96%", size: 45, h: 54, dur: "11.2s", delay: "2.3s", sway: "3.8s", ci: 6, label: "85%", ls: 11 },
];

function isPreview(root) {
  return root.getAttribute("data-dd-preview") === "true";
}

function readSeen() {
  try {
    if (window.Cookies) return window.Cookies.get(COOKIE_NAME);
    const m = document.cookie.match(new RegExp("(?:^|; )" + COOKIE_NAME + "=([^;]*)"));
    return m ? decodeURIComponent(m[1]) : null;
  } catch (e) {
    return null;
  }
}

function writeSeen() {
  try {
    if (window.Cookies) {
      window.Cookies.set(COOKIE_NAME, "1", { expires: COOKIE_EXPIRES, path: "/", sameSite: "Lax" });
      return;
    }
  } catch (e) { /* fall through to manual cookie */ }
  document.cookie = COOKIE_NAME + "=1; expires=" + COOKIE_EXPIRES.toUTCString() + "; path=/; SameSite=Lax";
}

// ---- Balloons ----
function spawnBalloons(root, isMobile) {
  const container = root.querySelector("[data-dd-balloons]");
  if (!container) return;
  const data = isMobile ? BALLOON_DATA.slice(0, 7) : BALLOON_DATA;
  container.innerHTML = "";
  data.forEach((b) => {
    const wrap = document.createElement("div");
    wrap.className = "dd-balloon";
    wrap.setAttribute("data-bid", String(b.id));
    wrap.style.left = b.left;
    wrap.innerHTML =
      '<div class="dd-balloon__float" style="animation:ddFloatUp ' + b.dur + ' linear ' + b.delay + ' infinite">' +
        '<div class="dd-balloon__sway" style="animation:ddSway ' + b.sway + ' ease-in-out infinite">' +
          '<div class="dd-balloon__body" style="width:' + b.size + 'px;height:' + b.h + 'px;background:' + BALLOON_COLORS[b.ci] + '">' +
            '<div class="dd-balloon__gloss"></div>' +
            '<div class="dd-balloon__knot" style="background:' + KNOT_COLORS[b.ci] + '"></div>' +
            '<div class="dd-balloon__label" style="font-size:' + b.ls + 'px">' + b.label + '</div>' +
          '</div>' +
          '<div class="dd-balloon__string"></div>' +
        '</div>' +
      '</div>';
    wrap.addEventListener("click", () => burstBalloon(wrap));
    container.appendChild(wrap);
  });
}

function burstBalloon(el) {
  if (!el || el.dataset.bursting) return;
  el.dataset.bursting = "1";
  el.style.pointerEvents = "none";
  const rect = el.getBoundingClientRect();
  const cx = rect.left + rect.width / 2;
  const cy = rect.top + rect.height / 2 - rect.height * 0.35;
  const fl = el.querySelector(".dd-balloon__float") || el;
  fl.style.animation = "ddBurst .32s cubic-bezier(0.36,0.07,0.19,0.97) forwards";
  el.style.transform = "";
  setTimeout(() => burstParticles(cx, cy), 32);
}

function burstParticles(cx, cy) {
  const colors = ["#FE6301", "#FF8C42", "#FFC857", "#E55A00", "#fff", "#ffedd5", "#ff6b6b", "#a78bfa"];
  const count = 14, dur = 580, particles = [];
  for (let i = 0; i < count; i++) {
    const angle = (i / count) * Math.PI * 2 + (Math.random() - 0.5) * 0.9;
    const dist = 55 + Math.random() * 95;
    const size = 4 + Math.random() * 7;
    const round = i % 3 !== 0;
    const p = document.createElement("div");
    p.style.cssText =
      "position:fixed;z-index:1020;pointer-events:none;will-change:transform,opacity;" +
      "border-radius:" + (round ? "50%" : "3px") + ";width:" + size + "px;height:" + size + "px;" +
      "background:" + colors[i % colors.length] + ";left:" + cx + "px;top:" + cy + "px;transform:translate(-50%,-50%)";
    document.body.appendChild(p);
    particles.push({ el: p, dx: Math.cos(angle) * dist, dy: Math.sin(angle) * dist, rot: Math.random() * 360 });
  }
  const start = performance.now();
  const tick = (now) => {
    const t = Math.min((now - start) / dur, 1);
    const ease = 1 - Math.pow(1 - t, 3);
    const gravity = t * t * 80;
    let alive = false;
    particles.forEach((p) => {
      if (!p.el.parentNode) return;
      const x = cx + p.dx * ease;
      const y = cy + p.dy * ease + gravity;
      const opacity = t < 0.55 ? 1 : Math.max(0, 1 - (t - 0.55) / 0.45);
      const scale = Math.max(0, 1 - t * 0.55);
      p.el.style.left = x + "px";
      p.el.style.top = y + "px";
      p.el.style.opacity = opacity;
      p.el.style.transform = "translate(-50%,-50%) scale(" + scale.toFixed(3) + ") rotate(" + (p.rot + t * 200) + "deg)";
      if (opacity > 0) alive = true; else p.el.remove();
    });
    if (t < 1 && alive) requestAnimationFrame(tick);
    else particles.forEach((p) => { if (p.el.parentNode) p.el.remove(); });
  };
  requestAnimationFrame(tick);
}

function attachMouseChase(root) {
  const scrim = root.querySelector("[data-dd-scrim]");
  if (!scrim) return;
  _mouseHandler = (e) => {
    root.querySelectorAll("[data-bid]").forEach((bal) => {
      if (bal.dataset.bursting) return;
      const rect = bal.getBoundingClientRect();
      const dx = e.clientX - (rect.left + rect.width / 2);
      const dy = e.clientY - (rect.top + rect.height / 2);
      const dist = Math.sqrt(dx * dx + dy * dy);
      const radius = 230;
      if (dist < radius) {
        const pull = Math.pow(1 - dist / radius, 1.4);
        const force = pull * 60;
        const angle = Math.atan2(dy, dx);
        bal.style.transition = "transform .45s cubic-bezier(0.22,1,0.36,1)";
        bal.style.transform =
          "translate(" + (Math.cos(angle) * force).toFixed(1) + "px," + (Math.sin(angle) * force).toFixed(1) + "px) scale(" + (1 + pull * 0.12).toFixed(3) + ")";
      } else if (bal.style.transform) {
        bal.style.transition = "transform .7s cubic-bezier(0.22,1,0.36,1)";
        bal.style.transform = "";
      }
    });
  };
  scrim.addEventListener("mousemove", _mouseHandler);
}

// ---- Confetti ----
function launchConfetti(root) {
  const canvas = root.querySelector("[data-dd-confetti]");
  if (!canvas) return;
  const ctx = canvas.getContext("2d");
  const dpr = window.devicePixelRatio || 1;
  const W = () => window.innerWidth, H = () => window.innerHeight;
  const resize = () => { canvas.width = W() * dpr; canvas.height = H() * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0); };
  resize();
  const colors = ["#FE6301", "#E55A00", "#FF8A3D", "#F5A623", "#FFC857", "#FAECE1", "#FFFFFF", "#2BB673", "#FF5E8A"];
  const rnd = (a, b) => a + Math.random() * (b - a);
  const pick = (arr) => arr[(Math.random() * arr.length) | 0];
  const make = (x, y, vx, vy) => ({ x, y, vx, vy, rot: rnd(0, Math.PI * 2), vr: rnd(-.3, .3), w: rnd(7, 13), h: rnd(9, 16), color: pick(colors), shape: Math.random() < .35 ? "circle" : "rect", tilt: rnd(0, Math.PI * 2), vt: rnd(.05, .14), op: 1 });
  const parts = [];
  for (let i = 0; i < 90; i++) { const a = rnd(-Math.PI * .62, -Math.PI * .42), sp = rnd(11, 19); parts.push(make(rnd(-10, 40), H() + 10, Math.cos(a) * sp, Math.sin(a) * sp)); }
  for (let i = 0; i < 90; i++) { const a = rnd(-Math.PI * .58, -Math.PI * .38) + Math.PI, sp = rnd(11, 19); parts.push(make(W() + 10, H() + 10, Math.cos(a) * sp, Math.sin(a) * sp)); }
  for (let i = 0; i < 60; i++) { const a = rnd(-Math.PI * .85, -Math.PI * .15), sp = rnd(8, 16); parts.push(make(W() / 2, H() * .42, Math.cos(a) * sp, Math.sin(a) * sp)); }
  const emitStart = performance.now();
  const grav = .17, drag = .992;
  const tick = (now) => {
    ctx.clearRect(0, 0, W(), H());
    const elapsed = now - emitStart;
    if (elapsed < 2200 && parts.length < 360) for (let i = 0; i < 4; i++) parts.push(make(rnd(0, W()), -15, rnd(-1.5, 1.5), rnd(2, 5)));
    for (let i = parts.length - 1; i >= 0; i--) {
      const p = parts[i];
      p.vy += grav; p.vx *= drag; p.x += p.vx; p.y += p.vy; p.rot += p.vr; p.tilt += p.vt;
      if (elapsed > 2600) p.op -= .012;
      if (p.y > H() + 30 || p.op <= 0) { parts.splice(i, 1); continue; }
      ctx.save(); ctx.translate(p.x, p.y); ctx.rotate(p.rot); ctx.scale(Math.cos(p.tilt), 1);
      ctx.globalAlpha = Math.max(0, p.op); ctx.fillStyle = p.color;
      if (p.shape === "circle") { ctx.beginPath(); ctx.ellipse(0, 0, p.w / 2, p.h / 2, 0, 0, Math.PI * 2); ctx.fill(); }
      else ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
      ctx.restore();
    }
    if (parts.length > 0) _raf = requestAnimationFrame(tick);
    else { _raf = null; ctx.clearRect(0, 0, W(), H()); }
  };
  _raf = requestAnimationFrame(tick);
}

function playChime() {
  try {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return;
    if (!_audioCtx) _audioCtx = new AC();
    const ac = _audioCtx;
    if (ac.state === "suspended") ac.resume();
    const now = ac.currentTime;
    [523.25, 659.25, 783.99, 1046.5].forEach((f, i) => {
      const o = ac.createOscillator(), g = ac.createGain();
      o.type = "triangle"; o.frequency.value = f;
      const t = now + i * 0.11;
      g.gain.setValueAtTime(0, t);
      g.gain.linearRampToValueAtTime(0.16, t + 0.02);
      g.gain.exponentialRampToValueAtTime(0.0008, t + 0.55);
      o.connect(g).connect(ac.destination);
      o.start(t); o.stop(t + 0.6);
    });
  } catch (e) { /* autoplay blocked / unsupported — silent */ }
}

function stopEffects(root) {
  if (_raf) { cancelAnimationFrame(_raf); _raf = null; }
  if (_mouseHandler) {
    const scrim = root.querySelector("[data-dd-scrim]");
    if (scrim) scrim.removeEventListener("mousemove", _mouseHandler);
    _mouseHandler = null;
  }
}

// ---- Lifecycle ----
function dismiss(root) {
  if (!isPreview(root)) writeSeen();
  stopEffects(root);
  root.classList.remove("dd-open");
  document.body.classList.remove("dd-birthday-lock");
}

function showPopup(root) {
  const isMobile = window.innerWidth < MOBILE_MAX;
  root.classList.toggle("dd-mobile", isMobile);
  root.classList.add("dd-open");
  document.body.classList.add("dd-birthday-lock"); // lock background scroll while open
  launchConfetti(root);
  spawnBalloons(root, isMobile);
  if (!isMobile) attachMouseChase(root);
  playChime();
}

function init() {
  const root = document.getElementById("dd-birthday-popup");
  if (!root) return; // no-op wherever the home pack loads without the partial

  if (!isPreview(root) && readSeen()) return; // already dismissed this event

  const close = root.querySelector("[data-dd-close]");
  const later = root.querySelector("[data-dd-later]");
  const scrim = root.querySelector("[data-dd-scrim]");
  const cta = root.querySelector("[data-dd-cta]");

  if (close) close.addEventListener("click", () => dismiss(root));
  if (later) later.addEventListener("click", () => dismiss(root));
  if (scrim) scrim.addEventListener("click", (e) => { if (e.target === scrim) dismiss(root); });
  if (cta) cta.addEventListener("click", () => {
    // Set the cookie, then let the anchor navigate to the thread naturally.
    if (!isPreview(root)) writeSeen();
    stopEffects(root);
  });

  setTimeout(() => showPopup(root), SHOW_DELAY_MS);
}

if (document.readyState !== "loading") init();
else document.addEventListener("DOMContentLoaded", init);
